export default __webpack_public_path__ + "82bee0d939b5a9e446bca2dfa8db2e05.png";